import React from 'react';

function FilterRole({ onChange }) {
  return (
    <div className="form-group">
      <label>Role</label>

      <select onChange={onChange} className="form-control">
        <option />
        <option>user</option>
        <option>admin</option>
      </select>
    </div>
  );
}

export default FilterRole;
